<template>
  <show-contract
    v-if="form.id"
    v-model="form"
    :building-complex-id="form.building_complex_id"
    :details="details"
    :errors="errors.getAll()"
    @update="updateContract"
    @cancel="cancel"
    @update-prop="clearErrorByName($event)"
  />
</template>

<script>
import { ContractsService } from '@/services/contracts.service';
import errors from '@/modules/_global/mixins/errors';
import ShowContract from '@/modules/building_complexes_contracts/components/ShowContract.vue';

export default {
  name: 'ShowInvoiceContract',

  components: {
    ShowContract
  },

  mixins: [errors],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      form: {},
      details: {}
    };
  },

  watch: {
    id: {
      deep: true,
      immediate: true,
      handler: 'getData'
    }
  },

  methods: {
    getData(v) {
      ContractsService.getById(this.id)
        .then(({ data }) => {
          this.form = { ...data };

          if (
            !this.form.building_ids.length &&
            this.form.buildings &&
            this.form.buildings.length
          ) {
            this.form.building_ids = this.form.buildings.map(el => el.id);
          }

          this.details = {
            business_customer: data.building_complex.business_customer,
            management_company: data.building_complex.management_company,
            building_complex_name: data.building_complex.name,
            service: data.service
          };
        })
        .catch(console.error);
    },

    cancel() {
      this.$emit('cancel');
    },

    updateContract() {
      ContractsService.update(this.form.id, this.form)
        .then(({ data }) => {
          this.$emit('updated', data);
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
